import type { Ref } from 'vue';
import type { toast } from 'vue3-toastify';
import { useNuxtApp } from 'nuxt/app';
import { parseApiErrorMessage } from '../utils/utils';

export function useToastError() {
	const app = useNuxtApp();
	const $toast = app.$toast as typeof toast;

	function displayError(error: unknown) {
		console.error('Error:', error);

		let msg = '';

		if (typeof error === 'string') {
			msg = error;
		}
		else {
			msg = parseApiErrorMessage(error);
		}

		$toast.error(msg);
	}

	return {
		displayError,
		executeWithLoader: <T extends any[], R>(fn: (...args: T) => Promise<R>, loader?: Ref<boolean>) => {
			return async (...args: T): Promise<R | void> => {
				if (loader?.value !== undefined) {
					loader.value = true;
				}
				try {
					return await fn(...args);
				}
				catch (error) {
					displayError(error);
				}
				finally {
					if (loader?.value !== undefined) {
						loader.value = false;
					}
				}
			};
		},
		$toast,
	};
};
